/**
 * Created by Mike Naughton on 2/23/18.
 * Singleton providing configuration information relating to authentication endpoints
 */
import URL from "url-js";
import Cookies from "js-cookie";

// set the authApiUrl to the production default
var authApiUrl = "https://api.hbkauth.production.hbkapps.com";
// however we still want to tie the authApiUrl to the current domain/stage this page was loaded from
var currentUrl = new URL(window.location.href);
if (currentUrl.hostname.indexOf("localhost") !== -1) {
  authApiUrl = Cookies.get("X-HBK-Auth-Url"); //may have been set by a test framework

  if (authApiUrl) {
    authApiUrl = decodeURIComponent(authApiUrl);
  } else {
    authApiUrl = "http://localhost:8101";
  }
} else if (currentUrl.hostname.indexOf("staging") !== -1) {
  authApiUrl = "https://api.hbkauth.staging.hbkapps.com";
}

export default {
  /**
   * Gets the base url for the auth API. Does not have a trailing slash.
   * @return {String} The base URL for the auth API, containing protocol and hostname.
   */
  getBaseUrl: function () {
    return authApiUrl;
  },
};



//////////////////
// WEBPACK FOOTER
// ./public/js/app/session-config.js
// module id = 483
// module chunks = 1